module.exports = __webpack_public_path__ + "img/ETH.ce6c5dda.gif";